export const SWR_CONFIG = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  errorRetryCount: 2,
  errorRetryInterval: 5000,
  onErrorRetry: (
    error: any,
    key: string,
    config: any,
    revalidate: any,
    { retryCount }: { retryCount: number }
  ) => {
    if (error.status === 401) return;
    if (retryCount >= SWR_CONFIG.errorRetryCount) return;
    setTimeout(() => revalidate({ retryCount }), SWR_CONFIG.errorRetryInterval);
  }
} as const;
